import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getCenterFinalCostVisibility(id: number) {
  return restApiClient
    .url(constructApiUrl(API.centers.getCenterFinalCostVisibility.url, { id }))
    .get<boolean>()
}
